import React, { useState, useEffect, useContext } from 'react';
import { Box, Grid, Paper, Typography, TextField, Checkbox, Table, TableHead, TableRow, TableCell, TableBody, Autocomplete , Radio , CircularProgress } from '@mui/material';
import ApiService from "../../functions/apiService";
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import AuthContext from '../../context/AuthContext';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import dayjs from 'dayjs';
import { useNavigate } from "react-router-dom";


const VolunteerSignup = () => {
	const { permission  , pages , user} = useContext(AuthContext);
	const [overtimeShifts, setOvertimeShift] = useState([])
	const [loading, setLoading] = useState(true);
	const [selectedShifts, setSelectedShifts] = useState([])
	const [key, setKey] = useState(1)
	const [overtimeHours , setOvertimeHours] = useState([])
	const [allowedVars , setAllowedVars] = useState({})
	const [shiftType , setShiftType] = useState([]);
	const [employees, setEmployees] = useState([])
	const [selectedEmp, setSelectedEmp] = useState('')
	const [formHeading, setFormHeading] = useState('')
	const [maxShifts, setMaxShifts] = useState(0)
    const [activeTab, setActiveTab] = useState('my-signups');
    const navigate = useNavigate();

	const loadEmployees = () => {
		ApiService.get('/employees-list?search=')
			.then(({ data }) => {
				var tempArr = []
				data.data.map((emp) => {
					var obj = emp
					obj.label = `${emp.employee_assignment.EA_Rank} ${emp.fullName}`
					tempArr.push(obj)
				})
				setEmployees(tempArr)
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	useEffect(()=>{
		loadEmployees()
	}, [])

	const loadShiftData = () => {
		setLoading(true)
		var body = {}
		if (selectedEmp) {
      body.Emp_Code = selectedEmp
    }
		ApiService.get('/listVolunteerSignup', body)
			.then(({ data }) => {
				setOvertimeShift(data?.data)
				var tempArr = []
				data?.data?.map((li) => {
					li.shifts.map((shift) => {
						if (shift.prevAction != null) {
							var tempObj = {
								ShiftDate: li.shiftDate,
								ShiftCode: shift.ShiftCode,
								Start_Time: shift.start_time,
								End_Time: shift.end_time
							}
							if (shift.prevAction == 'FULLTIME') {
								Object.assign(tempObj, { isFullTime: true })
							}
							tempArr.push(tempObj)
						}
					})
				})
				setSelectedShifts(tempArr)
				setLoading(false)
			})
			.catch(() => {
				setLoading(false)
		})
	}

	const loadHoursData = () => {
		setLoading(true)
		ApiService.get('/getHourShiftVolunteer')
			.then(({ data }) => {
				setOvertimeHours(data?.data)
				setLoading(false)
			})
			.catch(() => {
				setLoading(false)
			})
	}

	const loadMaxShifts = () => {
		setLoading(true)
		ApiService.get(`/getUserMaxShifts/${selectedEmp ? selectedEmp :  user?.Emp_Code}`)
			.then(({ data }) => {
				setMaxShifts(data?.data?.User_Value || 0)
				setLoading(false)
			})
			.catch(() => {
				setLoading(false)
			})
	}
	
	useEffect(()=>{
		loadHoursData()
		loadMaxShifts()
	} , [])

	let getAllowedVars = () => {
		ApiService.get('/v3Variables')
			.then((res) => {
					setAllowedVars(res?.data?.data)
					setFormHeading(res?.data?.data?.V3_VERBIAGE_VOLUNTEER ? "Per-diem Signup Form" : "Volunteer Signup Form")
			}).catch(({ error }) => {
				console.error('error', error)
			});
	}

	useEffect(()=>{
		getAllowedVars();
	}, [])

	const shiftData = () =>{
		ApiService.get('/shiftTypes').then(({ data }) => {
			setShiftType(data?.data || [])
		}).catch(() => {
			toast.error("Error")
		})
	}

	useEffect(()=>{
		shiftData()
	} , [])

	const selectShift = (date, code, type, time, shift_starttime, shift_endtime) => {
		var tempArr = [...selectedShifts];
		let extObj = tempArr.find((a) => a.ShiftDate == date && a.ShiftCode == code);

		if (extObj) {
			if (type == 'fulltime') {
				if (extObj.isFullTime) {
					const index = tempArr.findIndex(
						(a) => a.ShiftDate == date && a.ShiftCode == code && a.isFullTime
					);
					tempArr.splice(index, 1);
				} else {
					Object.assign(extObj, { isFullTime: true });
				}
			} else if (type == 'start_time') {
				Object.assign(extObj, { Start_Time: moment(time, "HH:mm").format("HH:mm:ss") });
				if (allowedVars?.V3_AUTO_PREFILL_LOGIC_FOR_PER_DIEM_SIGNUP_AVAILABILITY && !extObj.End_Time) {
					extObj.End_Time = shift_endtime;
				}
			} else if (type == 'end_time') {
				Object.assign(extObj, { End_Time: moment(time, "HH:mm").format("HH:mm:ss")});
				if (allowedVars?.V3_AUTO_PREFILL_LOGIC_FOR_PER_DIEM_SIGNUP_AVAILABILITY && !extObj.Start_Time) {
					extObj.Start_Time = shift_starttime;
				}
			} else if (type == 'staticTime') {
				Object.assign(extObj, { Start_Time: time.start, End_Time: time.end , isFullTime : false });
			}
		} else {
			var tempObj = {
				ShiftDate: date,
				ShiftCode: code,
			};

			var timeData = shiftType.find((ele) => ele.ShiftCode == tempObj.ShiftCode)

			if (type == "fulltime") {
				Object.assign(tempObj, { Start_Time: timeData?.Start_Time, End_Time: timeData?.End_Time , isFullTime: true});
			}
			if (type == "start_time") {
				Object.assign(tempObj, { Start_Time: moment(time, "HH:mm").format("HH:mm:ss") });
				if (allowedVars.V3_AUTO_PREFILL_LOGIC_FOR_PER_DIEM_SIGNUP_AVAILABILITY) {
					tempObj.End_Time = shift_endtime;
				}
			}
			if (type == "end_time") {
				Object.assign(tempObj, { End_Time: moment(time, "HH:mm").format("HH:mm:ss") });
				if (allowedVars.V3_AUTO_PREFILL_LOGIC_FOR_PER_DIEM_SIGNUP_AVAILABILITY) {
					tempObj.Start_Time = shift_starttime;
				}
			}
			if (type == "staticTime") {
				Object.assign(tempObj, { Start_Time: time.start, End_Time: time.end  , isFullTime: false});
			}

			tempArr.push(tempObj);
		}
		setSelectedShifts(tempArr);
	};

	const getTimeVal = (date, code, type, timevalue) => {
		const exists = selectedShifts?.find(
			(a) => a.ShiftDate == date && a.ShiftCode == code
		);

		if (exists && timevalue) {
			if (type === "start_time" && exists.Start_Time) {
				return dayjs(`2025-06-17T${exists.Start_Time}`).toDate();
			} else if (type === "end_time" && exists.End_Time) {
				return dayjs(`2025-06-17T${exists.End_Time}`).toDate(); 
			} else return null
		}
		else return null
	};

	const resetData = (date, code) => {
		var tempArr = [...selectedShifts]
		let extObj = tempArr.find((a) => a.ShiftDate == date && a.ShiftCode == code)
		if (extObj) {
			const index = tempArr.findIndex((a) => a.ShiftDate == date && a.ShiftCode == code)
			tempArr.splice(index, 1)
		}
		setSelectedShifts(tempArr)
	}

	const saveData = () => {
		setLoading(true)
		var tempArr = []
		selectedShifts.map((li) => {
			tempArr.push(li)
		})
		const body = {
			data: tempArr
		}
		if (selectedEmp) {
      body.Emp_Code = selectedEmp
    }
		ApiService.post('/saveVolunteerSignup', body)
			.then((data) => {
				setSelectedShifts([])
				loadShiftData()
				if (data?.errors?.length) {
					toast.error(
						<div>
							{data?.errors?.map((msg, index) => (
								<div key={index}>• {msg}</div>
							))}
						</div>
					);
				}
				toast.success(data?.message)
			})
			.catch(({ data }) => {
				setLoading(false)
				if (data?.errors?.length) {
					toast.error(
						<div>
							{data?.errors?.map((msg, index) => (
								<div key={index}>• {msg}</div>
							))}
						</div>
					);
				}
			})
	}

	const saveMaxShifts = () => {
		const body = {
			value: maxShifts,
			emp_code: selectedEmp || user?.Emp_Code
		}
		ApiService.post('/saveMaxShiftPerMonth', body)
			.then((data) => {
				toast.success(data?.message)
				loadMaxShifts()
			})
			.catch(({ data }) => {
				setLoading(false)
				toast.error(data?.message)
			})
	}

	useEffect(()=>{
		loadMaxShifts()
	} , [selectedEmp || user?.Emp_Code])

	useEffect(() => {
		loadShiftData()
	}, [selectedEmp])

	return (
		<>
			<Paper className="p-4" style={{ marginTop: "1rem" }}>
				<div className='mb-4'>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6} md={10}>
							<Typography variant="h5">Volunteer Signup</Typography>
						</Grid>

						{/* <Grid item xs={12} sm={6} md={2} sx={{ display: 'flex', justifyContent: 'end' }}>
							<ButtonTheme type='submit' variant="filled" color='primary'
								className='px-5' >
								Save
							</ButtonTheme>
						</Grid> */}
					</Grid>
				</div>

				<div style={{ marginTop: '25px' }}>
					<Row>
						<Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
							<div style={{ width: '170px' }} className={activeTab == 'my-signups' ? 'tab-active mx-1' : 'tab-white mx-1'}
								onClick={() => {
									setActiveTab('my-signups')
								}}>
								My Signups
							</div>
						</Col>

						<Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
							<div style={{ width: '170px' }} className={activeTab == 'all-signups' ? 'tab-active mx-1' : 'tab-white mx-1'}
								onClick={() => {setActiveTab('all-signups')
                                    navigate('/firehouse/all-signups')
								}}>
								All Signups
							</div>
						</Col>
					</Row>
				</div>
			</Paper>

			<Paper className="p-4" style={{ marginTop: "1rem" }}>
				<div className='mb-4'>
					<Grid container spacing={2} style={{display: 'flex', alignItems:'center'}}>
						<Grid item xs={12} sm={6} md={7}>
							<Typography variant="h5">{formHeading}</Typography>
						</Grid>
						
						{permission && permission.includes('Emp_Auth') &&
							<Grid item xs={12} sm={6} md={3}>
								<Autocomplete
									options={employees}
									getOptionLabel={(option) => option.label}
									onChange={(event, newValue) => setSelectedEmp(newValue?.Emp_Code || "")}
									renderInput={(params) => (
										<TextField
											{...params}
											placeholder="Employee"
											variant="outlined"
											fullWidth
											size="small"
											sx={{
												"& .MuiInputBase-root": {
													height: "48px",
													fontSize: "14px",
													display: "flex",
													alignItems: "center"
												}
											}}
										/>
									)}
								/>
							</Grid>
						}
						<Grid item xs={12} sm={6} md={!permission.includes('Emp_Auth') ? 5 : 2} sx={{display:'flex' , justifyContent:'end'}}>
							<ButtonTheme type='submit' variant="filled" color='primary'
								className='px-5' onClick={saveData}>
								Save
							</ButtonTheme>
						</Grid>
					</Grid>

					{allowedVars['V3_max_shifts_feature_for_warren'] &&
						<Grid item xs={12} sm={6} md={3} style={{marginTop:'1rem'}}>
							<div>Max Shifts per Month</div>
							<div style={{display: 'flex',  alignItems:'center', gap: '10px'}}>
								<span>
									<TextField
										value={maxShifts}
										defaultValue={maxShifts}
										onChange={(e) => setMaxShifts(e.target.value)}
											sx={{
												"& .MuiInputBase-root": {
													height: "40px",
													width: "70px",
													fontSize: "14px",
													display: "flex",
													alignItems: "center"
												}
											}}
										/>
								</span>
								<span>
									<ButtonTheme type='submit' variant="filled" color='primary' onClick={() =>{saveMaxShifts()}}>
										Save
									</ButtonTheme>
								</span>
							</div>
						</Grid>
					}
				</div>

				{loading || overtimeShifts.length === 0  && 
					<Box className="w-100 h-100 d-flex justify-content-center align-items-center" style={{ minHeight: '520px' }}>
						<CircularProgress />
					</Box>
				}

				{!loading && overtimeShifts && overtimeShifts.length > 0 &&
					<Box>
						<Table>
							<TableHead sx={{ backgroundColor: "#F4F4F4" }} >
								<TableRow>
									<TableCell className='px-1'></TableCell>
									<TableCell className='px-1'>Date</TableCell>
									<TableCell className='px-1'>Shift Type</TableCell>
									<TableCell className='px-1' align="left">Availability</TableCell>
								</TableRow>
							</TableHead>

							<TableBody>
								{overtimeShifts && overtimeShifts.length > 0 && overtimeShifts.map((li) => (
									<>
										{li.shifts.map((shift, i) => (
											<TableRow>
												<TableCell className='px-1'>
													<Checkbox label={`11/10/2024 Sunday Day`}
														checked={selectedShifts.length > 0 && selectedShifts?.find((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode && a.isFullTime)}
														onClick={(e) => selectShift(li.shiftDate, shift.ShiftCode, 'fulltime', '', shift.start_time, shift.end_time)}
														disabled={selectedShifts.filter((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode && !a.isFullTime).length > 0}

													/>
												</TableCell>

												<TableCell className='px-1'>
													<Row style={{ alignItems: 'center', fontSize: 14, color: '#666' }}>
														<Col>
															<span className="w-100">
																{moment(li.shiftDate).format('MM/DD/YYYY, ddd')}
															</span>
														</Col>
													</Row>
												</TableCell>

												<TableCell className='px-1'>
													<span
														style={{
															backgroundColor: 
																shift.name === "Day" || shift.name == '2' || shift.name == '3' ? 
																'rgba(255, 165, 0, 0.26)' : 'rgba(52, 152, 219, 0.16)',
															border: 
																shift.name === "Day" || shift.name == '2' || shift.name == '3' ?
																'1px solid rgba(255, 165, 0, 0.28)' : '1px solid rgba(52, 152, 219, 0.2)',
															color: 'rgba(0, 0, 0, 0.87)',
															fontSize: "14px",
															padding: 
																shift.name === "Day" || shift.name == '2' || shift.name == '3' ? 
																"7px 32px" : "7px 28px",
														}}
														className='rounded-5'
													>
														{shift.name}
													</span>
												</TableCell>

												<TableCell className='px-1'>
													<Row className='w-100' style={{ alignItems: 'center' }}>
														{!allowedVars['V3_Overtime_Signup_Custom_Time_Allow'] && 
															<Col md={'auto'}>But only available:</Col>
														}

														{allowedVars['V3_Overtime_Signup_Custom_Time_Allow'] ? 
															<Col md={9} style={{display:'flex'}}>
																{overtimeHours[shift?.name?.toUpperCase()]?.map((hr) => {
																	let checked = false;
																		let tempArr = [...selectedShifts];

																		const timePart = hr.split("(")[0].trim(); 
																		const [start, end] = timePart.split("-").map(s => s.trim());
																		const formatHour = (h) =>
																			h.toString().padStart(2, "0") + ":00:00";
																		const hrStart = formatHour(start);
																		const hrEnd = formatHour(end);

																		checked = tempArr.some(
																			(a) =>
																				a.ShiftDate == li.shiftDate &&
																				a.ShiftCode == shift.ShiftCode &&
																				a.Start_Time === hrStart &&
																				a.End_Time === hrEnd && !a.isFullTime 
																		);

																	return (
																		<Col md={4}>
																			<Radio label={hr}
																				checked={checked}
																				onClick={() => {
																					selectShift(li.shiftDate, shift.ShiftCode, 'staticTime', { start: hrStart, end: hrEnd })
																				}}
																				disabled={selectedShifts.filter((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode && a.isFullTime).length > 0}
																			/>
																			{hr}
																		</Col>
																	)
																})}
															</Col>
															:
															<>
																<Col md={4}>
																	<LocalizationProvider dateAdapter={AdapterDateFns}>
																		<TimePicker
																			className="m-0"
																			key={i + key}
																			value={getTimeVal(li.shiftDate, shift.ShiftCode, 'start_time', shift.start_time)}
																			onChange={(newValue) => selectShift(li.shiftDate, shift.ShiftCode, 'start_time', newValue, shift.start_time, shift.end_time)}
																			slotProps={{
																				textField: {
																					placeholder: shift.start_time
																						? dayjs(`2025-06-17T${shift.start_time}`).format("hh:mm A")
																						: "Select start time",
																				},
																			}}
																			sx={{
																				"& .MuiOutlinedInput-input": { color: 'black' },
																				width: "100%",
																				"& .MuiInputBase-root": {
																					height: '48px',
																					fontSize: '14px'
																				},
																			}}
																			disabled={selectedShifts?.find((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode && a.isFullTime)}
																		/>
																	</LocalizationProvider>
																</Col>

																<Col md={4}>
																	<LocalizationProvider dateAdapter={AdapterDateFns}>
																		<TimePicker
																			key={i + key}
																			className="m-0"
																			value={getTimeVal(li.shiftDate, shift.ShiftCode, 'end_time', shift.end_time)}
																			onChange={(newValue) => selectShift(li.shiftDate, shift.ShiftCode, 'end_time', newValue, shift.start_time, shift.end_time)}
																			slotProps={{
																				textField: {
																					placeholder: shift.end_time
																						? dayjs(`2025-06-17T${shift.end_time}`).format("hh:mm A")
																						: "Select end time",
																				},
																			}}
																			sx={{
																				"& .MuiOutlinedInput-input": { color: 'black' },
																				width: "100%",
																				"& .MuiInputBase-root": {
																					height: '48px',
																					fontSize: '14px'
																				},
																			}}
																			disabled={selectedShifts?.find((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode && a.isFullTime)}
																		/>
																	</LocalizationProvider>
																</Col>
															</>
														}

														<Col md={1} >
															<img src="/images/revert.png" width={22} height={22} style={{ cursor: 'pointer' }}
																onClick={() => resetData(li.shiftDate, shift.ShiftCode)} />
														</Col>

													</Row>
												</TableCell>
											</TableRow >
										))}
									</>
								))}
							</ TableBody>
						</Table>
						<div style={{display: 'flex', justifyContent: 'end'}}>
							<ButtonTheme type='submit' variant="filled" color='primary'
								className='px-5 mt-4' onClick={saveData}>
								Save
							</ButtonTheme>
						</div>
						</Box>
				}
			</Paper >
		</>
	)
}

export default VolunteerSignup